import {main} from './share';

main();
